// Three files, because the country data is big and not everyone can wait for
// it:
//
//   country-lookup  the rules. No data, so it is safe to import anywhere.
//   country         loads the data up front, for callers that need an answer
//                   while rendering.
//   country-async   loads it only when called, so pages that do not need it
//                   right away do not ship it (#2751).
//
// Keep the rules in country-lookup. When they lived in the other two, a fix
// went into one copy and shipped doing nothing.
//
// This file loads the data on demand. The Async suffix on each name is
// deliberate: these were once named like their twins in country.ts, and a
// fix aimed at one of them landed in the other.

import { USER_COUNTRY_FROM_IP_COOKIE } from '@lib/constants/common'
import {
  countryCodeFromLocale,
  findCountryByName,
  pickCountryForTimezone,
} from '@lib/utils/country-lookup'
import { parseCookies } from 'nookies'

export const getCountryFromCountryNameAsync = async (countryName: string) => {
  const { getAllCountries } = await import('countries-and-timezones')
  return findCountryByName(getAllCountries(), countryName)
}

export const getCountryFromLocaleAsync = async (locale: string) => {
  const { getCountry } = await import('countries-and-timezones')
  return getCountry(countryCodeFromLocale(locale))
}

export const getCountryForTimezoneAsync = async (timezone: string) => {
  const { getCountry, getCountriesForTimezone } = await import(
    'countries-and-timezones'
  )
  return pickCountryForTimezone(
    getCountriesForTimezone(timezone),
    getCountry(parseCookies()?.[USER_COUNTRY_FROM_IP_COOKIE])
  )
}
